import { Component, HostListener, OnInit } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import { CommonModule, DatePipe } from '@angular/common';
import { ColDef } from 'ag-grid-community';
import { SalesOrderService } from '../../features/salesOrder/services/salesOrder.service';
import { ToastrService } from 'ngx-toastr';
import { MatInputModule } from '@angular/material/input';
import { LayoutComponent } from '../../core/layout/layout.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-order-flow-assigned-list',
  standalone: true,
  imports: [CommonModule, AgGridAngular, MatInputModule, LayoutComponent, ReactiveFormsModule, FormsModule, DatePipe],
  templateUrl: './order-flow-assigned-list.component.html',
  styleUrl: './order-flow-assigned-list.component.scss',
})
export class OrderFlowAssignedListComponent {
  public viewPortSize: boolean = false;
  public rowData: any[] = [];

  columnDefs: (
    | {
        headerName: string;
        field: string;
        flex: number;
        cellRenderer?: undefined;
        floatingFilter?: undefined;
        filter?: undefined;
      }
    | {
        field: string;
        headerName: string;
        flex: number;
        cellRenderer: (params: string) => HTMLDivElement;
      }
  )[];

  search: any;
  page = 0;
  pageSize = 10;
  totalPages = 1;
  pageSizeOptions = [5, 10, 20, 50, 100];

  onCellClicked(params: any) {
    const orderServiceId = params.data?.orderServiceId;
    const id = params.data?.id;
    if (
      params.column.colId === 'action' &&
      params.event.target.dataset.action
    ) {
      let action = params.event.target.dataset.action;

      if (action === 'edit') {
        // this.onEdit(id);
      } else if (action === 'delete') {
        // this.onConfirmDelete(id);
      }
    } else {
      this.router.navigate([`order-flow-assigned-list/order-flow-assigned-view`], {
        queryParams: { id: id, orderServiceId: orderServiceId },
        
      });
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkViewportSize();
  }

  checkViewportSize() {
    if (window.innerWidth > 1200) {
      this.viewPortSize = true;
    } else {
      this.viewPortSize = false;
    }
    this.setAGColumn();
  }

  setAGColumn() {
    this.columnDefs = [
      {
        headerName: 'Task Name',
        field: 'taskName',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        headerName: 'Order Code',
        field: 'orderCode',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        headerName: 'Task Variant',
        field: 'taskVariant',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        headerName: 'ETA',
        field: 'eta',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        headerName: 'Expected Date',
        field: 'deadline',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        headerName: 'Status',
        field: 'status',
        flex: this.viewPortSize ? 1 : 0,
        cellRenderer: (params: any): HTMLDivElement => {
          const value = params.value || '';
          const span = document.createElement('span');

          let color = '';
          switch (value.toLowerCase()) {
            case 'new':
              color = 'blue';
              break;
            case 'in progress':
              color = 'orange';
              break;
            case 'pending':
              color = 'purple';
              break;
            case 'completed':
              color = 'green';
              break;
            case 'rejected':
              color = 'red';
              break;
            default:
              color = 'black';
          }

          span.style.color = color;
          span.style.fontWeight = '500';
          span.innerText = value;

          // 👇 Required: Return a proper HTMLDivElement
          const div = document.createElement('div');
          div.appendChild(span);
          return div;
        },
      },
    ];
  }

  public defaultColDef: ColDef = {
    filter: 'agTextColumnFilter',
    floatingFilter: true,
  };
  public rowSelection: 'single' | 'multiple' = 'multiple';
  public paginationPageSize = 10;
  public paginationPageSizeSelector: number[] | boolean = [10];
  public themeClass: string = 'ag-theme-quartz';

  constructor(
    private salesOrderService: SalesOrderService,
    private toastr: ToastrService,
    private datePipe: DatePipe,
    private router: Router,
  ){

  }

  ngOnInit(): void {
    this.checkViewportSize();
    this.fetchSalesOrders();
  }

  nextPage() {
    if (this.page + 1 < this.totalPages) {
      this.page++;
      this.fetchSalesOrders(this.pageSize);
    }
  }

  prevPage() {
    if (this.page > 0) {
      this.page--;
      this.fetchSalesOrders(this.pageSize);
    }
  }

  onPageSizeChange(event: Event): void {
    const newSize = Number((event.target as HTMLSelectElement).value);
    this.pageSize = newSize;
    this.page = 0;
    this.fetchSalesOrders(this.pageSize);
  }


  private fetchSalesOrders(pageSize: number = 10) {
    if (pageSize) {
      this.pageSize = pageSize;
    }
    const skip = this.page * this.pageSize;
    const input = {
      search: this.search,
      limit: this.pageSize,
      skip,
    }
    this.salesOrderService.findAllTaskAssignmentsWithPagination(input).subscribe({
      next: (orders: any) => {
        console.log('orders',orders);
        
        this.totalPages = Math.ceil(
          (orders?.total || orders?.taskAssignments?.length) / this.pageSize
        );        

        this.rowData = orders?.taskAssignments
          .map((order: any) => {
            return {
              id: order?.id || '--',
              orderServiceId: order?.orderServiceData?.orderData?.id || '--',
              taskName: order?.serviceTaskData?.taskData?.taskName || '--',
              orderCode: order?.orderServiceData?.orderData?.orderCode || '--',
              taskVariant: order?.variantName || '--',
              deadline: this.datePipe.transform(order?.deadline, 'dd/MM/yyyy') || '--',
              eta: order?.estimatedTime || '--',
              status: order?.serviceTaskStatus === 'InProgress' ? 'In Progress' : order?.serviceTaskStatus || '--',
            };
          })
      },
      error: (error: any) => {
       this.toastr.error(error, 'Error');
      },
    });
  }
}
